export const MaxPageSizeForApi = 2_147_483_647;
